import { render, staticRenderFns } from "./AdminNewTweet.vue?vue&type=template&id=15850161&scoped=true&"
import script from "./AdminNewTweet.vue?vue&type=script&lang=js&"
export * from "./AdminNewTweet.vue?vue&type=script&lang=js&"
import style0 from "./AdminNewTweet.vue?vue&type=style&index=0&id=15850161&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15850161",
  null
  
)

export default component.exports